import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../css/LoginForm.css";
import { useLoginUser } from "../../../_helper/actions/mutation/login";
import { setAuthToken } from "../../../_helper/constant/auth";
import PasswordInput from "./PasswordInput";
import CuButton from "../../../all-patient/components/CuButton";
import { toast } from "react-toastify";
import CuSpinner from "../../../common_component/component/CuSpinner";

const LoginForm = ({ setIsForgotPassword, setSteps }) => {
  const [signinData, setSigninData] = useState({
    mobileNo: "",
    password: "",
  });
  const [err, setErr] = useState("");
  const [otpLogin, setOtpLogin] = useState(false);
  const [showOtp, setShowOtp] = useState(false);
  const [resendDisabled, setResendDisabled] = useState(true);
  const [countdown, setCountdown] = useState(60); // Set initial countdown time
  const [selectedOption, setSelectedOption] = useState("cufront"); // Default to clinic
  const [msubdomain, setMSubDomain] = useState("");

  const navigate = useNavigate();
  let loginmutation = useLoginUser("login/");

  useEffect(() => {
    let timer;
    if (err?.length > 0) {
      timer = setTimeout(() => {
        setErr("");
      }, 5000);
    }
    return () => clearTimeout(timer);
  }, [err]);

  // Determine the default selection based on the subdomain
  useEffect(() => {
    const hostname = window.location.hostname; // Get current domain
    const subdomain = hostname.split(".")[0]; // Extract subdomain

    console.log(subdomain);
    setMSubDomain(subdomain);

    if (
      subdomain.includes("pharmacy") ||
      ["venus-pharmacy", "moon-pharmacy"].includes(subdomain)
    ) {
      setSelectedOption("pharmacy");
    } else if (
      subdomain.includes("doctor") ||
      ["venus", "moon"].includes(subdomain)
    ) {
      setSelectedOption("cufront");
    }
  }, []);

  const getIsDisabled = () => {
    const { mobileNo, password } = signinData;
    if (mobileNo?.length > 0 && password?.length > 0) {
      return false;
    } else {
      return true;
    }
  };

  const onChangeHandler = (e, fieldName) => {
    setSigninData((prev) => ({
      ...prev,
      [fieldName]: e.target.value,
    }));
  };

  const validateForm = () => {
    const { mobileNo } = signinData;
    if (mobileNo?.length !== 10) {
      setErr("Please enter valid mobile number");
      return false;
    }
    return true;
  };

  // It handles submit

  const submitHandler = (e) => {
    e.preventDefault();
    const isValidation = validateForm();
    if (isValidation) {
      const { mobileNo, password } = signinData;
      loginmutation.mutate(
        {
          email: `${mobileNo}@${selectedOption}.com`,
          password,
          domain: selectedOption,
        },
        {
          onSuccess: (data) => {
            setAuthToken(data.access_token);
            localStorage.setItem("access_token", data.access_token);
            localStorage.setItem("refresh_token", data.refresh_token);

            if (selectedOption === "pharmacy") {
              navigate("/new/pharmacy");
            } else {
              navigate(
                "/new/appointment?all_clinic=false&view=day&session=All"
              );
            }

            // if (localStorage.getItem("access_token")) {
            //   navigate("/new/appointment");
            // }
          },
          onError: (err) => {
            setErr("Invalid user credentials");
          },
        }
      );
    }
  };

  const handleSetForgetPassword = () => {
    setIsForgotPassword(true);
    setSteps((prev) => prev + 1);
  };

  useEffect(() => {
    if (resendDisabled && countdown > 0) {
      const timer = setInterval(() => {
        setCountdown((prev) => prev - 1);
      }, 1000);
      return () => clearInterval(timer);
    } else if (countdown === 0) {
      setResendDisabled(false); // Enable resend button when countdown reaches 0
    }
  }, [resendDisabled, countdown]);

  const sendOtpMutation = useLoginUser("login_otp/");

  const handleSendOtp = (e) => {
    e.preventDefault();
    const isValidation = validateForm();
    if (isValidation) {
      const { mobileNo } = signinData;
      sendOtpMutation.mutate(
        {
          action: "send",
          mobile: mobileNo,
        },
        {
          onSuccess: () => {
            toast.success("Otp sent successfully");
            setShowOtp(true);
            setResendDisabled(true);
            setCountdown(60);
          },
          onError: (err) => {
            toast.error(err.response.data.message);
          },
        }
      );
    }
  };

  const handleOtpLogin = (e) => {
    e.preventDefault();
    const isValidation = validateForm();
    if (isValidation) {
      const { mobileNo, otp } = signinData;
      loginmutation.mutate(
        {
          action: "otp",
          email: mobileNo,
          domain: selectedOption,
          otp: otp,
        },
        {
          onSuccess: (data) => {
            setAuthToken(data.access_token);
            localStorage.setItem("access_token", data.access_token);
            localStorage.setItem("refresh_token", data.refresh_token);
            if (selectedOption === "pharmacy") {
              navigate("/new/pharmacy");
            } else {
              navigate(
                "/new/appointment?all_clinic=false&view=day&session=All"
              );
            }
          },
          onError: (err) => {
            toast.error(err.response.data.message);
          },
        }
      );
    }
  };

  return (
    <>
      <div className="auth-header">Sign In</div>
      {msubdomain === "localhost" && (
        <div className="radio-options">
          <label>
            <input
              type="radio"
              name="userType"
              value="cufront"
              checked={selectedOption === "cufront"}
              onChange={() => setSelectedOption("cufront")}
            />
            Clinic
          </label>
          <label>
            <input
              type="radio"
              name="userType"
              value="pharmacy"
              checked={selectedOption === "pharmacy"}
              onChange={() => setSelectedOption("pharmacy")}
            />
            Pharmacy
          </label>
        </div>
      )}
      {otpLogin ? (
        <form
          className="login-form"
          onSubmit={showOtp ? handleOtpLogin : handleSendOtp}
        >
          <input
            placeholder="Mobile number"
            value={signinData.mobileNo}
            type="tel"
            onChange={(e) => onChangeHandler(e, "mobileNo")}
          />
          {err && <div className="text-xs text-red-500">{err}</div>}

          {showOtp && (
            <input
              placeholder="Enter OTP"
              type="number"
              value={signinData.otp}
              onChange={(e) => onChangeHandler(e, "otp")}
            />
          )}
          <div className="text-sm text-blue-400 w-full text-right cursor-pointer">
            <span onClick={() => setOtpLogin(false)}>Login Via Password</span>
          </div>
          <CuButton
            // disabled={getIsDisabled()}
            type={"submit"}
            isLoading={
              showOtp ? loginmutation.isLoading : sendOtpMutation.isLoading
            }
            className={"bg-black p-2 text-white rounded-lg"}
          >
            {showOtp ? "Login" : "Send Otp"}
          </CuButton>
          {showOtp && (
            <div className="w-full text-right">
              {resendDisabled ? (
                `Resend Otp in ${countdown} sec`
              ) : (
                <div
                  className="cursor-pointer text-blue-400"
                  onClick={handleSendOtp}
                >
                  {sendOtpMutation.isLoading ? <CuSpinner /> : "Resend Otp"}
                </div>
              )}
            </div>
          )}
        </form>
      ) : (
        <form className="login-form" onSubmit={submitHandler}>
          <input
            placeholder="Mobile number"
            value={signinData.mobileNo}
            type="number"
            onChange={(e) => onChangeHandler(e, "mobileNo")}
          />

          <PasswordInput
            placeholder={"Password"}
            value={signinData.password}
            onChange={(e) => onChangeHandler(e, "password")}
          />
          <div
            className="text-sm text-blue-400 w-full text-right cursor-pointer"
            onClick={() => setOtpLogin(true)}
          >
            <span onClick={() => setOtpLogin(true)}>Login Via OTP</span>
          </div>
          <CuButton
            className={`bg-black text-white h-[40px] rounded-lg`}
            disabled={getIsDisabled()}
            type="submit"
            isLoading={loginmutation.isLoading}
          >
            Sign In
          </CuButton>
        </form>
      )}
      <div className="forgot-password-link" onClick={handleSetForgetPassword}>
        Forgot password?
      </div>
      {err?.length > 0 && <div className="auth-errors">{err}</div>}
    </>
  );
};

export default LoginForm;
